export const LOG_ACTIONS = {
  NEW_CASE_INBOUND: "new-case-inbound",
  NEW_CASE_MOTHER: "new-case-mother",
  STATUS_CHANGE: "status-change",
  STATUS_EDIT: "status-edit",
  NEW_CASE_FOLLOWUP: "new-case-followup",
  TRANSFER_CASE: "transferCase",
  TRANSFER_CASE_LANG: "transferCase-lang",
  UNASSIGN_LANG: "unassign-lang",
  CASE_ASSIGN_SELECTED: "case-assign-selected",
  UNASSIGN_CASES: "unassign-cases",
  CASE_ASSIGN_AUTO: "case-assign-auto",
};
